// extracted by mini-css-extract-plugin
export default {"externalPublish":"PublicationInfoForm_externalPublish__4YsNF"};